/**
 * Release gate for the re-point WRITE.
 *
 * Detect-only release: support can find and inspect broken accounts but cannot change one. A follow-up PR
 * adds a dry-run mode and an account-merge tool, so none of the re-point code is removed — flip
 * REPOINT_ENABLED to re-open the UI path.
 *
 * This closes the UI path ONLY. The staff-bff and users-api write endpoints stay live and keep their own
 * permission gates; disabling a button is not an access control.
 *
 * It lives in its own module so tests can `vi.mock` it and still exercise the full re-point flow, which
 * would otherwise lose its coverage the moment the gate went in.
 */
export const REPOINT_ENABLED = false;

export const REPOINT_DISABLED_NOTICE =
  "Re-pointing is not enabled in this release. This account can be inspected but not changed.";
